import { epic$, store$ } from "@redux/store";
import { map, filter, distinctUntilChanged } from "rxjs";
import dispatchEvent from "./components/trackOnDemand";
import totalDeliveryValueSlice from "./redux/slices";
import { getCommunityLoggerEpic, getPlanLoggerEpic, getSpecLoggerEpic } from "./redux/epics";

const eventTrackingSelector = (state) => state?.totalDeliveryValue;
const isTdvEvent = (eventTracking) => eventTracking?.type === 'tdv';
const { actions: totalDeliveryValueActions, reducer: totalDeliveryValueReducers} = totalDeliveryValueSlice;


const firedTdvEvents = (eventTracking) => {
    const event = {
        label: eventTracking.event,
        ...eventTracking.parameters
    }
    dispatchEvent(event);
};

store$.pipe(
    map(eventTrackingSelector),
    filter(isTdvEvent),
    distinctUntilChanged()
    ).subscribe(firedTdvEvents);

export {
    totalDeliveryValueActions,
    totalDeliveryValueReducers
};

epic$.next(getPlanLoggerEpic);
epic$.next(getSpecLoggerEpic);
epic$.next(getCommunityLoggerEpic);